// extracted by mini-css-extract-plugin
export default {"icon":"ScrollUpButton_icon__VwnRy"};